import React from "react";
import { Box, H3 } from "ui-components";
import get from "lodash/get";

const FeatureToggle = props => {
  const { component, render, children, appSettings, width = "100%" } = props;
  const debugMode = localStorage.getItem("debug") === "1";
  let wrapperStyles = { width };
  let titleStyle = { display: "none" };

  if (debugMode) {
    wrapperStyles = {
      borderColor: "gray.1",
      borderWidth: 1,
      borderRadius: 2,
      borderStyle: "dashed",
      my: 2,
      p: 4
    };

    titleStyle = {
      display: "block",
      mb: 4
    };
  }

  const enabled =
    get(component, "enable") === true ||
    get(appSettings, `${get(component, "lookup")}.enable`, false);

  return (
    <Box sx={wrapperStyles}>
      <H3 color="green" sx={titleStyle}>
        {get(component, "name", "")}
      </H3>

      {enabled ? (render ? render({ ...component }) : children) : null}
    </Box>
  );
};

export default FeatureToggle;
